import axios from "axios";
import axiosInstance from "../../../../Utils/axios";
import { paginationQueryParams } from "../../../../Utils/paginationParam";

let cancelToken;

const dimensionModURL = "api/v1/cost-center/cost-center-dimension";

//obtaining the paginated data
export const getDimension = ({ rowsPerPage, search, sortOrder, pageNo }) => {
  if (cancelToken) {
    cancelToken.cancel("Operation canceled due to new request.");
  }
  cancelToken = axios.CancelToken.source();

  return axiosInstance.get(`${dimensionModURL}/list?${paginationQueryParams(rowsPerPage, search, sortOrder, pageNo)}`, {
    cancelToken: cancelToken.token,
  });
};

//obtaining all fiscal sessions
export const getAllDimension = () => axiosInstance.get(`${dimensionModURL}/list?ordering=-id`);

//obtaining the previous page data from paginated data
export const getPrevious = (previous) => axiosInstance.get(previous);

//obtaining the next page data from paginated data
export const getNext = (next) => axiosInstance.get(next);

//obtaining the particular page data from paginated data
export const getPageDimension = ({ number, rowsPerPage, search }) =>
  axiosInstance.get(`${dimensionModURL}/list?${paginationQueryParams(rowsPerPage, search, "", number)}`);

//creating function
export const createDimension = (body) => axiosInstance.post(`${dimensionModURL}/create`, body);
//updating function
export const updateDimension = (id, body) => axiosInstance.patch(`${dimensionModURL}/update/${id}`, body);

//searching function
export const handleSearch = ({ search, rowsPerPage, sortOrder }) =>
  axiosInstance.get(`${dimensionModURL}/list?offset=0&limit=${rowsPerPage} &ordering=${sortOrder} &search=${search}`);

// checking the redundant data
export const checkRedundantDataDimensionName = (e, cancelToken) =>
  axiosInstance.get(`${dimensionModURL}/list?name=${e.target.value.trim()}`, {
    cancelToken: cancelToken.token,
  });
